import SEO from '../../components/common/SEO';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <SEO 
        title="Privacy Policy"
        description="Read the privacy policy of Ashoka IAS Academy regarding data collection, storage, and user information safety."
      />
      {/* Hero */}
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-hero__title">Privacy Policy</h1>
          <p className="legal-hero__subtitle">Last updated: June 15, 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="legal-content">
        <div className="container legal-content__inner">

          <div className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Ashoka IAS Academy ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Information We Collect</h2>
            <h3>2.1 Personal Information</h3>
            <p>We collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register for our courses or programs</li>
              <li>Fill out enquiry forms</li>
              <li>Subscribe to our newsletters</li>
              <li>Contact us via phone, email, or contact forms</li>
              <li>Participate in our test series or mock exams</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Educational background</li>
              <li>Course preferences</li>
              <li>Payment information (processed securely through third-party payment gateways)</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>When you visit our website, we automatically collect certain information about your device, including:</p>
            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Pages visited and time spent on pages</li>
              <li>Referring website addresses</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect for the following purposes:</p>
            <ul>
              <li><strong>Course Administration:</strong> To process your enrollment, manage your course access, and provide educational services</li>
              <li><strong>Communication:</strong> To respond to your inquiries, send course updates, and provide customer support</li>
              <li><strong>Marketing:</strong> To send you information about new courses, programs, and promotional offers (you can opt-out anytime)</li>
              <li><strong>Improvement:</strong> To analyze usage patterns and improve our website and services</li>
              <li><strong>Legal Compliance:</strong> To comply with applicable laws and regulations</li>
              <li><strong>Security:</strong> To protect against fraudulent or illegal activity</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Information Sharing and Disclosure</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
            <ul>
              <li><strong>Service Providers:</strong> With trusted third-party service providers who assist us in operating our website, conducting our business, or servicing you (e.g., payment processors, email service providers)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to respond to legal processes</li>
              <li><strong>Business Transfers:</strong> In connection with any merger, sale of company assets, or acquisition</li>
              <li><strong>With Your Consent:</strong> When you have given us explicit permission to share your information</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Your Rights</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request access to the personal information we hold about you</li>
              <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time</li>
              <li><strong>Data Portability:</strong> Request a copy of your data in a structured, machine-readable format</li>
            </ul>
            <p>To exercise these rights, please contact us at <a href="mailto:ashokaiasacademy123@gmail.com">ashokaiasacademy123@gmail.com</a></p>
          </div>

          <div className="legal-section">
            <h2>8. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, and understand user preferences. You can control cookie settings through your browser preferences. However, disabling cookies may limit your ability to use certain features of our website.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are intended for individuals aged 18 and above. We do not knowingly collect personal information from children under 18. If you believe we have collected information from a child, please contact us immediately.
            </p>
          </div>

          <div className="legal-section">
            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated policy on our website with a new "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the updated policy.
            </p>
          </div>

          <div className="legal-section">
            <h2>12. Contact Us</h2>
            <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:</p>
            <div className="legal-contact">
              <p><strong>Ashoka IAS Academy</strong></p>
              <p>Email: <a href="mailto:ashokaiasacademy123@gmail.com">ashokaiasacademy123@gmail.com</a></p>
              <p>Phone: +91 88228 23003 | +91 91814 11843</p>
              <p><strong>Guwahati Office:</strong><br />
                1st Floor, Nath Complex, Opp. Aruna Memorial Hospital,<br />
                Rajgarh Road, Bhangagarh, Guwahati – 781005</p>
              <p><strong>Nagaon Office:</strong><br />
                Sankar Mission, Panigaon Chari Ali, Opp. Reliance Trends,<br />
                Nagaon – 782001</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
